export class SurCaseSurgeryEventsInfoModel {
  SurCaseEventId: number;
  SurCaseId: number;
  PatChestOpenSurgeryInd: string;
  PatCarioBypassRelEventInd: string;
  PatCarioBypassRelEventNotes: string;
  Updatedby: string;
}
